export default __webpack_public_path__ + "static/media/void.61a40b27.png";